import { HttpClient } from '@angular/common/http';
import { Constants } from 'src/@smartmanufacturing/common/constants';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SortDirection } from 'src/@smartmanufacturing/common/enum';
import { DataMapper } from 'src/app/user-management/shared/models/data-mapper';
import { Employee, EmployeeList, ReportToEmployee } from 'src/app/user-management/user-management-setup/models/employee';
import { BaseApi } from 'src/backend/api/base-api';
import { map, catchError } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class EmployeeService {
    get baseUrl(): string { return Constants.CORE_API_BASE_URL; }
    constructor(private http: HttpClient, private baseApi: BaseApi) { }

    getLazyLoadedEmployees(data: any): Observable<DataMapper<Employee>> {
        let params = '';
        if (data?.pageIndex) {
            params += 'offset=' + data?.pageIndex.toString();
        }
        if (data?.pageSize) {
            if (params.length > 0) {
                params += '&';
            }
            params += 'limit=' + data?.pageSize.toString();
        }
        if (data?.status) {
            if (params.length > 0) {
                params += '&';
            }
            params += `status=` + data?.status;
        }
        if (data?.sortDirection !== SortDirection.None) {
            if (params.length > 0) {
                params += '&';
            }
            params += 'sortDirection=' + data?.sortDirection;
        }
        if (data?.sortField) {
            if (params.length > 0) {
                params += '&';
            }
            params += 'sortField=' + data?.sortField;
        }
        if (data?.searchValue) {
            if (params.length > 0) {
                params += '&';
            }
            params += 'phrase=' + data?.searchValue;
        }
        return this.http.get<DataMapper<Employee>>(this.baseApi.encodeURL(Constants.API_EMPLOYEE_LAZYLOADED + '?' + params));
    }
    getAllReportToEmployees(): Observable<ReportToEmployee[]> {
        return this.http.get<ReportToEmployee[]>(this.baseApi.encodeURL(Constants.API_EMPLOYEES_GETALL_REPORTTO));
    }
    getAllEmployees(): Observable<EmployeeList[]> {
        return this.http.get<EmployeeList[]>(this.baseApi.encodeURL(Constants.API_EMPLOYEES));
    }
    getAllEmployeesList(): Observable<EmployeeList[]> {
      return this.http.get<EmployeeList[]>(this.baseApi.encodeURL(Constants.API_EMPLOYEES_GETALLLIST));
  }
    getAllChatBotNextBestAction(): Observable<[]> {
      return this.http.get<[]>(this.baseApi.encodeURL(Constants.API_ChatBotNextBestAction));
    }
    NextBestActionRead(data:any): Observable<[]> {
      return this.http.post<[]>(this.baseApi.encodeURL(Constants.API_UpdateReadNextBestAction),data);
    }
    getEmployeeByCode(code: string): Observable<Employee> {
        return this.http.get<Employee>(this.baseApi.encodeURL(Constants.API_EMPLOYEE_BY_CODE + '/' + code));
    }

    activateEmployee(id: number): Observable<any> {
        return this.http.get<any>(this.baseApi.encodeURL(Constants.API_EMPLOYEE_ACTIVATE + '/' + id));
    }
    deactivateEmployee(id: number): Observable<any> {
        return this.http.get<any>(this.baseApi.encodeURL(Constants.API_EMPLOYEE_DEACTIVATE + '/' + id));
    }

    createEmployee(data: any): Observable<any> {
        return this.http.post<any>(this.baseApi.encodeURL(Constants.API_EMPLOYEE_CREATE), data);
    }
    editEmployee(data: any): Observable<any> {
        return this.http.put<any>(this.baseApi.encodeURL(Constants.API_EMPLOYEE_EDIT), data);
    }
    changeEmployeeEmail(data: any): Observable<any> {
        return this.http.put<any>(this.baseApi.encodeURL(Constants.API_EMPLOYEE_CHANGE_EMAIL), data);
    }
    getEmployeeDetails(code: string): Observable<Employee> {
        return this.http.get<Employee>(this.baseApi.encodeURL(Constants.API_EMPLOYEE_DETAILS + '/' + code));
    }

    getBulkUploadUserManagementExportExcel(data: any): Observable<Blob> {
        const fileUrl = this.baseUrl + 'UserManagementBulkUpload/downloadExportExcelFileDetail';
        return this.http.post(fileUrl, data, {
          responseType: 'arraybuffer'
        }).pipe(
          map((res: ArrayBuffer) => {
            return new Blob([res], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
          }),
          catchError((error: any) => {
            throw error;
          })
        );
      }

      getBulkUploadUserManagementSampleExcel(data: any): Observable<Blob> {
        const fileUrl = this.baseUrl + 'UserManagementBulkUpload/downloadSampleUserManagementFile';
        return this.http.post(fileUrl , data , {
          responseType: 'arraybuffer'
        }).pipe(
          map((res: ArrayBuffer) => {
            return new Blob([res], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
          }),
          catchError((error: any) => {
            throw error;
          })
        );
      }

      uploadUserManagementMasterData(file: File): Observable<any> {
        const formData = new FormData();
        formData.append('file', file, file.name);
        const fileUrl = this.baseUrl + 'UserManagementBulkUpload/uploadUserManagementMasterData';
        return this.http.post(fileUrl, formData, {
          responseType: 'json'
        });
      }

}
